import { createContext, useContext } from 'react';
import { FormLabelSize, FormSize } from './types';
import { MouseEvent, KeyboardEvent } from 'react';
export interface FormControlContextState {
  required?: boolean;
  hasError?: boolean;
  readOnly?: boolean;
  onLabelClick?: (e: MouseEvent<HTMLLabelElement> | KeyboardEvent<HTMLLabelElement>) => void;
  // default is medium
  size?: FormSize;
  // default is large
  labelSize?: FormLabelSize;
}

export const FormControlContext = createContext<FormControlContextState>({});

export const useFormControlContext = () => useContext(FormControlContext);
